<template lang="html">

  <section class="add-game">
    <AdminHeader></AdminHeader>
    <h1 v-if="$route.params.slug" class="mb-5">Spiel bearbeiten</h1>
    <h1 v-else class="mb-5">Spiel hinzufügen</h1>
    <v-text-field outlined v-model="name_de" label="Name DE"></v-text-field>
    <v-text-field outlined v-model="name_en" label="Name EN"></v-text-field>
    <v-select v-model="genre" multiple :items="genres" outlined label="Genre" item-value="id"
              item-text="name"></v-select>
    <v-select v-model="publisher" multiple :items="publishers" outlined label="Verlag" item-value="id"
              item-text="name"></v-select>
    <v-text-field type="number" outlined v-model="price" label="Preis" suffix="€"></v-text-field>
    <v-row justify="center" align="center">
      <v-col cols="5">
        <v-text-field type="number" v-model="playerMin" outlined label="Spieler Min"></v-text-field>
      </v-col>
      <v-col cols="2" class="text-center">
        bis
      </v-col>
      <v-col cols="5">
        <v-text-field type="number" v-model="playerMax" outlined label="Spieler Max"></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="5">
        <v-text-field type="number" v-model="playTimeMin" outlined label="Zeit Min"></v-text-field>
      </v-col>
      <v-col cols="2" class="text-center">
        bis
      </v-col>
      <v-col cols="5">
        <v-text-field type="number" v-model="playTimeMax" outlined label="Zeit Max"></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="5">
        <v-text-field type="number" v-model="ageMin" outlined label="Alter Min"></v-text-field>
      </v-col>
      <v-col cols="2" class="text-center">
        bis
      </v-col>
      <v-col cols="5">
        <v-text-field type="number" v-model="ageMax" outlined label="Alter Max"></v-text-field>
      </v-col>
    </v-row>
    <v-textarea outlined v-model="description_de" label="Beschreibung DE"></v-textarea>
    <v-textarea outlined v-model="description_en" label="Beschreibung EN"></v-textarea>
    <v-menu ref="date_menu" v-model="date_menu" :close-on-content-click="false" :return-value.sync="date"
            transition="scale-transition" offset-y min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field v-model="dateFormatted" @blur="date = parseDate(dateFormatted)" label="Datum"
                      v-on="on"></v-text-field>
      </template>
      <v-date-picker v-model="date" no-title @change="$refs.date_menu.save(date)">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="date_menu = false">Abbrechen</v-btn>
      </v-date-picker>
    </v-menu>
    <v-file-input
        v-model="selectedFile"
        accept="image/png, image/jpeg, image/bmp"
        placeholder="Bild auswählen"
        prepend-icon="mdi-camera"
        label="Bild"
        @change="onFileSelected"
    ></v-file-input>
    <v-btn v-if="$route.params.slug" @click="editGame" class="button">Bearbeiten</v-btn>
    <v-btn v-else @click="addGame" class="button">Hinzufügen</v-btn>
  </section>

</template>

<script lang="js">
import AdminHeader from "./AdminHeader";
import GameService from "../../services/GameService";
import GenreService from "../../services/GenreService";
import PublisherService from "../../services/PublisherService";

export default {
  name:       'add-game',
  components: {AdminHeader},
  props:      [],
  mounted () {
    this.getGame();
    this.getGenres();
    this.getPublishers();
  },
  data () {
    return {
      'id':             null,
      'name_de':        "",
      'name_en':        "",
      'genres':         [],
      'genre':          [],
      'publishers':     [],
      "publisher":      [],
      'price':          0.0,
      'playerMin':      0,
      'playerMax':      0,
      'playTimeMin':    0,
      'playTimeMax':    0,
      'ageMin':         0,
      'ageMax':         0,
      "description_de": "",
      "description_en": "",
      "date":           new Date().toISOString().substr(0, 10),
      "dateFormatted":  this.formatDate(new Date().toISOString().substr(0, 10)),
      "date_menu":      false,
      "selectedFile":   null,
      "fileData":       null
    }
  },
  methods:  {
    addGame () {
      console.log(this.selectedFile);
      GameService.addGame(this.name_de, this.name_en, this.genre, this.publisher, this.price, this.playerMin, this.playerMax, this.playTimeMin, this.playTimeMax, this.ageMin, this.ageMax, this.description_de, this.description_en, this.date, this.selectedFile)
                 .then(res => {
                   console.log(res);
                   this.$router.push("/admin/games");
                 })
                 .catch(err => console.log(err));
    },
    editGame () {
      console.log(this.selectedFile);
      GameService.editGame(this.id, this.name_de, this.name_en, this.genre, this.publisher, this.price, this.playerMin, this.playerMax, this.playTimeMin, this.playTimeMax, this.ageMin, this.ageMax, this.description_de, this.description_en, this.date, this.selectedFile)
                 .then(res => {
                   console.log(res);
                   this.$router.push("/admin/games");
                 })
                 .catch(err => console.log(err));
    },
    getGame () {
      if (this.$route.params.slug) {
        GameService.getGameBySlug(this.$route.params.slug).then(res => {
          console.log(res);
          const game   = res.data.game;
          this.id      = game.id;
          this.name_de = game.name.de;
          this.name_en = game.name.en;
          res.data.genres.forEach(genre => {
            this.genre.push(genre.id);
          })
          res.data.publishers.forEach(publisher => {
            this.publisher.push(publisher.id);
          })
          this.price          = game.price;
          this.playerMin      = game.playerMin;
          this.playerMax      = game.playerMax;
          this.playTimeMin    = game.playTimeMin;
          this.playTimeMax    = game.playerMax;
          this.ageMin         = game.ageMin;
          this.ageMax         = game.ageMax;
          this.description_de = game.description.de;
          this.description_en = game.description.en;
          this.date           = new Date(Date.parse(game.release)).toISOString().substr(0, 10);
        })
      }

    },
    getGenres () {
      GenreService.getGenres().then(res => {
        this.genres = res.data;
      })
                  .catch(err => console.log(err));
    },
    getPublishers () {
      PublisherService.getPublishers().then(res => {
        this.publishers = res.data;
      })
                      .catch(err => console.log(err));
    },
    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate (date) {
      if (!date) return null;

      const [day, month, year] = date.split('.');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    onFileSelected () {
      const reader = new FileReader();
      reader.readAsText(this.selectedFile);
      reader.onload = () => {
        this.fileData = reader.result;
      };
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date);
    }
  },
  watch:    {
    date () {
      this.dateFormatted = this.formatDate(this.date);
    }
  }
}


</script>

<style scoped lang="scss">
.add-game {

}
</style>
